import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {GetInvoices as GetInvoicesQuery, GetInvoicesVariables} from 'nutshell-graphql-types';

import GET_INVOICES from '../queries/get-invoices.graphql';

export const useGetInvoices = (leadId: string, skip?: boolean) => {
    const {
        data,
        loading: isLoading,
        networkStatus,
        error,
        refetch,
    } = useQuery<GetInvoicesQuery, GetInvoicesVariables>(GET_INVOICES, {
        variables: {leadId: leadId},
        skip,
        fetchPolicy: 'cache-and-network',
    });

    const invoices = data ? data.invoices : null;

    const isFirstLoading = isFirstLoad(networkStatus);

    return {
        invoices: invoices ? invoices : [],
        isLoading,
        isFirstLoad: isFirstLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
